/**
 * GENERADO por scripts/generar-catalogo-regimen-uso.mjs — no se edita a mano.
 *
 * c_RegimenFiscal y c_UsoCFDI (CFDI 4.0) tal como vienen en database/catalogs.db
 * (cfdi_40_regimenes_fiscales y cfdi_40_usos_cfdi), solo claves vigentes.
 * Lo usa lib/cfdi-rules.js; lib/__tests__/cfdi-rules-catalogo.test.js falla si
 * este archivo y el catálogo dejan de coincidir. Para regenerarlo, desde
 * public_html/theme2026:
 *
 *   node scripts/generar-catalogo-regimen-uso.mjs [ruta/a/catalogs.db]
 */

/** Régimen → a qué tipo de persona aplica. */
export var REGIMENES_FISCALES = {
  "601": {"fisica":false,"moral":true},
  "603": {"fisica":false,"moral":true},
  "605": {"fisica":true,"moral":false},
  "606": {"fisica":true,"moral":false},
  "607": {"fisica":true,"moral":false},
  "608": {"fisica":true,"moral":false},
  "610": {"fisica":true,"moral":true},
  "611": {"fisica":true,"moral":false},
  "612": {"fisica":true,"moral":false},
  "614": {"fisica":true,"moral":false},
  "615": {"fisica":true,"moral":false},
  "616": {"fisica":true,"moral":false},
  "620": {"fisica":false,"moral":true},
  "621": {"fisica":true,"moral":false},
  "622": {"fisica":false,"moral":true},
  "623": {"fisica":false,"moral":true},
  "624": {"fisica":false,"moral":true},
  "625": {"fisica":true,"moral":false},
  "626": {"fisica":true,"moral":true}
};

/** Uso del CFDI → tipo de persona y regímenes del receptor que lo admiten. */
export var USOS_CFDI = {
  "G01": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "G02": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","616","620","621","622","623","624","625","626"]},
  "G03": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "I01": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "I02": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "I03": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "I04": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "I05": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "I06": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "I07": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "I08": {"fisica":true,"moral":true,"regimenes":["601","603","606","612","620","621","622","623","624","625","626"]},
  "D01": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "D02": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "D03": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "D04": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "D05": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "D06": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "D07": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "D08": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "D09": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "D10": {"fisica":true,"moral":false,"regimenes":["605","606","607","608","611","612","614","615","625"]},
  "S01": {"fisica":true,"moral":true,"regimenes":["601","603","605","606","607","608","610","611","612","614","615","616","620","621","622","623","624","625","626"]},
  "CP01": {"fisica":true,"moral":true,"regimenes":["601","603","605","606","607","608","610","611","612","614","615","616","620","621","622","623","624","625","626"]},
  "CN01": {"fisica":true,"moral":false,"regimenes":["605"]}
};
